export const GET_OFFERS = "@iweb/GET_OFFERS"
export const SET_OFFER_STATUS = "@iweb/SET_OFFER_STATUS"
export const SET_OFFER_AGREED_TIME = "@iweb/SET_OFFER_AGREED_TIME"
export const SET_OFFER_STARTED_TIME = "@iweb/SET_OFFER_STARTED_TIME"
export const SET_OFFER_COMPLETED_TIME = "@iweb/SET_OFFER_COMPLETED_TIME"
export const SET_OFFER_EARNINGS = "@iweb/SET_OFFER_EARNINGS"
export const SET_WORKHOURS = "@iweb/SET_WORKHOURS"
export const OFFER_UPDATED = "@iweb/OFFER_UPDATED"
